import type { SVGProps } from 'react';

const HomeMarker = (props: SVGProps<SVGSVGElement>) => (
  <svg width="22px" height="29px" viewBox="0 0 22 29" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>My home marker</title>
    <defs>
      <ellipse id="homeMarker-path-1" cx="12" cy="21" rx="7" ry="3" />
      <filter
        x="-50.0%"
        y="-83.3%"
        width="200.0%"
        height="333.3%"
        filterUnits="objectBoundingBox"
        id="homeMarker-filter-2"
      >
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.35 0" type="matrix" in="shadowBlurOuter1" />
      </filter>
      <path
        d="M15.7633331,7.29999982 L12.4,4.13333333 C12.162963,3.95555556 11.837037,3.95555556 11.6,4.13333333 L8.23666688,7.29999982 C8.08644501,7.42679284 7.99983959,7.61342143 8,7.80999979 L8,12.8333328 C8,13.2015227 8.29847704,13.5 8.66666685,13.5 L15.3333331,13.5 C15.701523,13.5 16,13.2015227 16,12.8333328 L16,7.80999979 C16.0001604,7.61342143 15.913555,7.42679284 15.7633331,7.29999982 Z"
        id="homeMarker-path-3"
      />
      <filter
        x="-87.5%"
        y="-52.6%"
        width="275.0%"
        height="247.4%"
        filterUnits="objectBoundingBox"
        id="homeMarker-filter-4"
      >
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.35 0" type="matrix" in="shadowBlurOuter1" />
      </filter>
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-673.000000, -697.000000)">
        <g transform="translate(97.000000, 548.000000)">
          <g transform="translate(575.000000, 148.000000)">
            <g fill="black" fillOpacity="1">
              <use filter="url(#homeMarker-filter-2)" href="#homeMarker-path-1" />
            </g>
            <g transform="translate(-0.000000, 0.000000)">
              <g transform="translate(4.500000, 1.500000)">
                <g fill="#006AFF" fillRule="nonzero">
                  <path d="M7.5,-3.33066907e-16 C3.35786438,-3.33066907e-16 6.66133815e-16,3.35786438 6.66133815e-16,7.5 C6.66133815e-16,13.5 7.5,21 7.5,21 C7.5,21 15,13.5 15,7.5 C15,5.51087633 14.2098237,3.60322198 12.8033009,2.19669914 C11.396778,0.790176303 9.48912367,-3.33066907e-16 7.5,-3.33066907e-16 Z M7.5,10.5 C5.84314575,10.5 4.5,9.15685425 4.5,7.5 C4.5,5.84314575 5.84314575,4.5 7.5,4.5 C9.15685425,4.5 10.5,5.84314575 10.5,7.5 C10.5,8.29564947 10.1839295,9.05871121 9.62132034,9.62132034 C9.05871121,10.1839295 8.29564947,10.5 7.5,10.5 Z" />
                </g>
                <g transform="translate(4.500000, 4.500000)">
                  <circle cx="3" cy="3" r="3" />
                </g>
              </g>
            </g>
            <g fillRule="nonzero">
              <use fill="black" fillOpacity="1" filter="url(#homeMarker-filter-4)" href="#homeMarker-path-3" />
              <use fill="#FFFFFF" href="#homeMarker-path-3" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default HomeMarker;
